var map = {
	"./symbol_0.png": 65329,
	"./symbol_1.png": 25384,
	"./symbol_2.png": 62243,
	"./symbol_3.png": 57018,
	"./symbol_4.png": 14965,
	"./symbol_5.png": 32076,
	"./symbol_6.png": 16903,
	"./symbol_7.png": 29214,
	"./symbol_8.png": 28105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71084;